import { Component, OnInit } from '@angular/core';
import { UploadService } from 'src/app/service/upload.service';
import { Upload } from '../upload';

@Component({
  selector: 'app-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.scss']
})
export class UploadFormComponent implements OnInit {

  currentUpload:Upload;
  dropzoneActive:boolean=false;

  constructor() { }

  dropzoneState($event:boolean){
    this.dropzoneActive=$event;
  }

  handleDrop(fileList: FileList){

    // let filesIndex=_.range(fileList.length)
    // _.each(filesIndex,(idx)=>{
    //   this.currentUpload=new Upload(fileList[idx]);
    //   this.upSvc.pushUpload(this.currentUpload)
    // })
  }

  ngOnInit() {
  }

}
